import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'react-final-form';

// Global Types
import { AppState } from 'services/types';
import { SchemaEntityTypeId } from 'services/schemas/types';

// Global Components
// @ts-ignore
import EntityOptions from 'components/EntityOptions';

// Global Form
// @ts-ignore
import RenderDropdown from 'forms/RenderDropdown';

// Global Selectors
// @ts-ignore
import { makeSelectEntityTypeValue } from 'services/entityTypes/selectors';

interface OwnProps {
    entityTypeId?: SchemaEntityTypeId;
    name: string;
    validate?: any;
    useCompositeKey?: boolean;
    multiple?: boolean;
    entityId?: number;
    renderComponenent?: any;
    nullOnUnmount?: boolean;
    disabled?: boolean;
}

interface ConnectedProps {
    entityTypeName?: string;
}

type Props = OwnProps & ConnectedProps;

/**
 * A components that hides all the config needed for displaying an dropdown of entities in a form
 */
export class EntityDropdownField extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            entityTypeId,
            name,
            validate,
            useCompositeKey,
            entityTypeName,
            multiple,
            entityId,
            disabled = false,
            nullOnUnmount = false,
            renderComponenent = RenderDropdown
        } = this.props;

        return (
            <EntityOptions
                entityTypeId={entityTypeId}
                useCompositeKey={useCompositeKey}
                entityId={entityId}
            >
                <Field
                    component={renderComponenent}
                    subscription={{
                        value: true,
                        touched: true,
                        error: true
                    }}
                    name={name}
                    validate={validate}
                    label={entityTypeName || 'Area'}
                    placeholder={`Add ${
                        entityTypeName ? entityTypeName.toLowerCase() : 'area'
                    }`}
                    fluid
                    search
                    selection
                    clearable
                    selectOnBlur={false}
                    multiple={multiple}
                    nullOnUnmount={nullOnUnmount}
                    disabled={disabled}
                />
            </EntityOptions>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityTypeName: makeSelectEntityTypeValue('name')
});

export default connect(mapStateToProps)(EntityDropdownField);
